<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">句式：</span>
                <a-input placeholder="" class="seachs" v-model="seach.prompt"/>
            </div>
            <div class="seachList  ">   <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                查询
            </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button> </div>
          <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>
      <a-button class="top_btn" type="primary" @click="()=>{visible = true; title='添加指令' ;this.editId=''; }"  >
        添加
      </a-button>
      <a-button class="top_btn" type="primary"  >
        <a-popconfirm
            title="此操作将永久删除, 是否继续?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="confirm('')"
            @cancel="()=>{}"
        >
          <a >删除</a>
        </a-popconfirm>
      </a-button>
      <p style="color: #f00">注：指令中包含文章，用{article}表示； {industry_name}行业名称；{imglink}代表图片链接;{link1}、{link2}代表链接1、链接2；关键词，用***表示</p>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,  }"
                >
             <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <div slot="logo" slot-scope="text, record">
             <div class="img" style="width: 40px;height: 40px;display: flex; align-items:center; justify-content:center; " @click="()=>{visibleImg=true;tableImg=text}">
               <img :src="text" alt=""   style="display: block;max-width: 100%;max-height: 100%">

             </div>
            </div>
          <span slot="customer_count" slot-scope="text, record">
          <router-link :to="`/CustomerManagement/CustomerList?aAgentId=${record.id}`" v-if="text*1>0">{{text}}</router-link>
            <template v-else>{{text}}</template>
          </span>

            <span slot="action" slot-scope="text, record">

        <a @click="(record)=>{visible = true;; title='修改'; editId=text.id ; }" >编辑 <a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm( record.id )"
                  @cancel="()=>{}"
          >
   <a >删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <AgentForm :visible="visible" :title="title" :editId="editId"
                     @changVisible=" () => { this.visible = false;this.editId=''; this.getList()}  "/>

      <a-modal  :footer="null"
                title="查看大图"
                :visible="visibleImg"
                @cancel="()=>{visibleImg=false}"
      >
        <img :src="tableImg" alt="" style="width: 100%;display: block">
      </a-modal>
    </div>

</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import AgentForm from "./components/agentForm"
    import {changStatus, removeById,orderList} from "../../../../../utils/utils"
    const columns = [
        {
            title: "改写单页编辑器内容指令",
            dataIndex: "rewrite_content_prompt",
            key: "rewrite_content_prompt",
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return { product_ids:[],
                resetSeachdata:true,
                fieldNames: {label: 'name', value: 'id', children: 'children'},
              visibleImg: false,
                tableImg: "",
                seachList: {
                    category: [],
                    status: []
                },
                seach: {
                  prompt: "",

                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true

                },
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/Agent/AgentList"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        components: {AgentForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            // confirm(id) {
            //     removeById(API.service.DELE,id).then(res => {
            //         if (res == true) {
            //             this.getList()
            //             this.selectedRowKeys=[]
            //         }
            //     })
            // },
          confirm(id) {
            if(id==''){
              id=this.selectedRowKeys
            }else{
              id=[id]
            }
            removeById(API.service.DELES,id).then(res => {
              if (res == true) {
                this.getList()
                this.selectedRowKeys=[]
              }
            })
          },
            resetSeach() {
                this.loading = true
                this.seach = {
                  prompt: "",
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))

                API.service.GET_LISTS({page: page || 1, ...seachData,type:5,}).then(res => {
                    this.data = res.data.data.list.data
                    this.pagination.total = res.data.data.list.total
                    this.pagination.pageSize = res.data.data.list.per_page
                    this.pagination.current = res.data.data.list.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            editLanguage(name, type) {
                if (type == '5') {
                    this.confirm(this.selectedRowKeys)
                }
                let url
                let dataArr = []
                let dataJson = {}
                this.selectedRowKeys.map((item, index) => {
                    dataJson = {}
                    dataJson.id = item;
                    dataJson[name] = type;
                    dataArr.push(dataJson)
                })
                if (name == 'status') {
                    changStatus(API.service.CHANG_STATUS,dataArr).then(res => {
                        if (res == true) {
                            this.getList()
                            this.selectedRowKeys = []
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
